export default __webpack_public_path__ + "static/emilie-even-320949b6225641c826b15ff550efd01d.jpg";